var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUserShare = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 280 280"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M120 150c44.183 0 80 45.817 80 90 0 5.523-4.477 10-10 10H30c-5.523 0-10-4.477-10-10 0-44.183 35.817-90 80-90zm100-60c5.523 0 10 4.477 10 10v20h20c5.523 0 10 4.477 10 10s-4.477 10-10 10h-20v20c0 5.523-4.477 10-10 10s-10-4.477-10-10v-20h-20c-5.523 0-10-4.477-10-10s4.477-10 10-10h20v-20c0-5.523 4.477-10 10-10M110 30c27.614 0 50 22.386 50 50s-22.386 50-50 50-50-22.386-50-50 22.386-50 50-50"
})));
export default SvgUserShare;